import React, { useEffect, useState } from 'react';
import AdminSidebar from "../../components/admin/AdminSidebar";
import DashboardHeader from "../../components/admin/DashboardHeader";
import CashReport from "../../components/reports/CashReport";
import { useAuth } from "../../contexts/AuthContext";
import { fetchCompanyPos, fetchCashierProfiles, formatTerminalOptionLabel } from "../../services/posService";

/** Rapports admin : rapport de caisse sur toutes les caisses ou une caisse précise. */
const Reports = () => {
    const { selectedOrganization } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [timeRange, setTimeRange] = useState('today');
    const [currency, setCurrency] = useState('CDF');
    const [terminals, setTerminals] = useState([]);
    const [cashierNameById, setCashierNameById] = useState({});

    useEffect(() => {
        if (!selectedOrganization?.id) return;
        let cancelled = false;
        (async () => {
            try {
                const list = await fetchCompanyPos(selectedOrganization.id);
                const profiles = await fetchCashierProfiles(list.map((t) => t.managerId));
                if (cancelled) return;
                const names = Object.fromEntries(Object.entries(profiles).map(([id, p]) => [id, p.name]));
                setCashierNameById(names);
                setTerminals(list.map((t) => ({
                    id: t.id,
                    name: formatTerminalOptionLabel(t),
                    managerId: t.managerId,
                    cashierName: names[t.managerId] || null,
                })));
            } catch (error) {
                if (!cancelled) setTerminals([]);
            }
        })();
        return () => { cancelled = true; };
    }, [selectedOrganization?.id]);

    return (
        <div className="min-h-screen bg-slate-50 flex">
            <AdminSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} activeSection="reports" />

            <div className="flex-1 min-h-screen transition-all duration-300 overflow-hidden">
                <div className="min-h-screen p-6">
                    <DashboardHeader
                        timeRange={timeRange}
                        onTimeRangeChange={setTimeRange}
                        currency={currency}
                        onCurrencyChange={setCurrency}
                        onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
                    />
                    <div className="mt-6">
                        <CashReport organization={selectedOrganization} terminals={terminals} cashierNameById={cashierNameById} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reports;
